import { styled } from 'styled-components';

import { hexToRGB, typography } from '@/styles/helpers';

export const ScTournamentLimits = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;

  @container tournament-card (width > 626px) {
    margin-top: 24px;
    max-width: 305px;
    margin-inline: auto;
  }

  &:has(> :nth-child(2)) {
    justify-content: space-between;
  }

  & > .limit {
    display: flex;
    align-items: center;
    gap: 8px;
    ${typography['caption1regular']};
    letter-spacing: 0;
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};

    & > svg path {
      fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }
`;
